import languageObject from "../../../../translations";
import {AddIcon, CloseIcon, Dialog, Flex, Input, InputProps} from "@fluentui/react-northstar";
import * as React from "react";
import {useCallback, useEffect, useState} from "react";

type Props = {
    show: boolean,
    onClose: () => void,
    onConfirm: (email: string) => void,
}

type State = {
    email: string,
}

const initialState: State = {
    email: "",
}

export const AddEmailDialog = (props: Props) => {
    const [state, setState] = useState<State>({...initialState});

    useEffect(() => {
        if (!props.show) setState({...initialState});
    }, [props.show]);

    const handleAddEmail = () => {
        props.onConfirm(state.email);
    }

    const handleEmailChange = useCallback((e: React.SyntheticEvent, data: InputProps | undefined) => {
        const value = (data?.value ?? "") + "";
        setState((prevState): State => ({...prevState, email: value}));
    }, []);

    const isEmailValid = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(state.email);

    return (
        <Dialog
            open={props.show}
            closeOnOutsideClick
            onConfirm={handleAddEmail}
            confirmButton={{
                content: languageObject.translate("Add"),
                disabled: !isEmailValid,
                icon: <AddIcon outline/>,
            }}
            header={languageObject.translate("AddUpn")}
            headerAction={{
                content: <CloseIcon/>,
                onClick: props.onClose,
                title: languageObject.translate("Close"),
                styles: {margin: "-5px 0 0 15px"}
            }}
            content={
                <Flex fill>
                    <Input
                        fluid
                        autoFocus
                        placeholder={languageObject.translate("EnterEmailAddress")}
                        value={state.email}
                        onChange={handleEmailChange}
                    />
                </Flex>
            }
        />
    )
}